import { render, staticRenderFns } from "./permission-modal.vue?vue&type=template&id=0dda8193&scoped=true&"
import script from "./permission-modal.vue?vue&type=script&lang=ts&"
export * from "./permission-modal.vue?vue&type=script&lang=ts&"
import style0 from "./permission-modal.vue?vue&type=style&index=0&id=0dda8193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda8193",
  null
  
)

export default component.exports